// extracted by mini-css-extract-plugin
export var askAiIcon = "_p3-k";
export var category = "_p3-a";
export var categoryHeader = "_p3-f";
export var container = "_p3-0";
export var group = "_p3-b";
export var groupItems = "_p3-g";
export var groupSeparator = "_p3-l";
export var highlight = "_p3-8";
export var loading = "_p3-1";
export var noResults = "_p3-3";
export var placeholder = "_p3-2";
export var resultContent = "_p3-5";
export var resultIcon = "_p3-d";
export var resultItem = "_p3-h";
export var resultMeta = "_p3-9";
export var resultSubtitle = "_p3-7";
export var resultSuffix = "_p3-j";
export var resultTitle = "_p3-6";
export var resultsList = "_p3-4";
export var searchGroup = "_p3-e";
export var selected = "_p3-i";
export var subgroup = "_p3-c";